export default {
  title: 'Taxe',
  subtitle: 'Suprascrierea taxei de serviciu pentru {{company}}.',
  card_title: 'Taxă de serviciu',
  banner: {
    default_summary: 'Implicit partener: {{percentage}}% · min {{min}} · max {{max}}.',
    override_hint: 'Suprascrie mai jos pentru a seta o taxă diferită pentru acest restaurant.',
    suggested_summary: 'Valori inițiale sugerate: {{percentage}}% · min {{min}} · max {{max}}.',
    suggested_hint: 'Ajustați-le mai jos și salvați pentru a percepe o taxă de serviciu la acest restaurant.',
    own_fee_hint: 'Acest restaurant percepe propria taxă, setată mai jos.',
    saved_summary: 'Ultimele valori salvate: {{percentage}}% · min {{min}} · max {{max}}.',
    saved_hint:
      'Taxa de serviciu este dezactivată. Salvați aceste valori, sau modificați-le mai întâi, pentru a o reactiva.',
  },
  form: {
    recommended: 'Recomandat: {{value}}',
    percentage: {
      label: 'Procent taxă de serviciu',
      tooltip: 'Procentul din valoarea comenzii perceput clientului ca taxă de serviciu.',
    },
    min_amount: {
      label: 'Suma minimă a taxei de serviciu',
      tooltip: 'Taxele calculate sub această sumă sunt rotunjite în sus la aceasta.',
    },
    max_amount: {
      label: 'Suma maximă a taxei de serviciu',
      tooltip: 'Taxa de serviciu nu depășește niciodată această sumă, indiferent de valoarea comenzii.',
    },
  },
  limits:
    'Trebuie să rămână în limitele Foodamigos: max {{max_percentage}}% / {{max_amount}}, minim cel puțin {{min_amount}}.',
  not_charged_notice:
    'Momentan nu se percepe nicio taxă de serviciu la acest restaurant. Salvați o taxă mai jos pentru a o activa.',
  zero_percentage_warning:
    'Un procent de 0% nu dezactivează taxa de serviciu: taxele calculate sub suma minimă sunt rotunjite în sus la aceasta, deci fiecare comandă este taxată cel puțin cu minimul.',
  buttons: {
    edit: 'Editează',
    cancel: 'Anulează',
    save: 'Salvează',
    reset_to_default: 'Resetează la implicit-ul partenerului',
    turn_off: 'Dezactivează taxa de serviciu',
  },
  toasts: {
    load_error: 'Nu s-au putut încărca setările taxei de serviciu.',
    failed_to_save_changes: 'Nu s-au putut salva modificările',
    changes_got_saved: 'Modificările au fost salvate',
    reset_to_default: 'Suprascriere eliminată — se aplică implicit-ul partenerului.',
    reset_to_default_skipped:
      'Suprascrierea a fost eliminată — nu se percepe nicio taxă de serviciu până când nu salvați una.',
    turned_off: 'Taxa de serviciu a fost dezactivată. Valorile dvs. sunt păstrate pentru când o reactivați.',
  },
};
